import { Divider } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import { Button } from "src/components/shared/Button/Button";
import { useTheme } from "src/hooks";
import type { ISummaryItem } from "src/pages/Summary/Summary.types";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setToVerify } from "src/redux/slices/verifySlice";
import { Flex } from "src/styled";

import VerifyButton from "../VerifyButton";
import { getVerifyFromSummary } from "../VerifyEntries/VerifyEntries.utils";
interface Props {
  audit: boolean | undefined;
  reviews: ISummaryItem[];
  refetchReviews: () => void;
}
const QuickVerify = ({ audit, reviews, refetchReviews }: Props) => {
  const theme = useTheme();
  const { aid } = useParams();
  const { toVerify } = useSelector(state => state.verifySlice);
  const dispatch = useDispatch();

  const handleSelect = (unSelect?: boolean) => {
    if (unSelect) {
      dispatch(setToVerify([]));
      return;
    }
    const items = reviews.map(review => getVerifyFromSummary(review));
    dispatch(setToVerify(items));
  };

  const navigatePath = `/summary/${audit ? "audits/audit" : "reviews/review"}/${aid}`;
  return (
    <Flex>
      <Divider
        size="sm"
        orientation="vertical"
        color={(theme.primaryColor ?? "gray") as string}
        opacity={0.6}
      />
      <Button variant="outline" onClick={() => handleSelect()} ml={10}>
        Select All
      </Button>
      <div style={{ marginLeft: 10 }}>
        <VerifyButton
          request="review-verify-entry"
          navigatePath={navigatePath}
          refetch={refetchReviews}
          title="Verify selected"
        />
      </div>

      {toVerify.length > 0 ? (
        <Flex ml={10} align="center">
          <Button
            onClick={() => handleSelect(true)}
            variant="outline"
            w={30}
            h={30}
            p={0}>
            <IconX size={20} />
          </Button>
        </Flex>
      ) : (
        <div style={{ width: 35, height: 30 }}></div>
      )}
    </Flex>
  );
};
export default QuickVerify;
